/**
 * @generated SignedSource<<ed0756babaf3ee9d390272bf57f5350f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
export type useSearchSuggestionsContentfulQuery$variables = {
  locale: string;
};
export type useSearchSuggestionsContentfulQuery$data = {
  readonly categories: {
    readonly items: ReadonlyArray<{
      readonly categoryCollection: {
        readonly items: ReadonlyArray<{
          readonly categoryNameExternal: string | null | undefined;
          readonly categoryNameInternal: string | null | undefined;
          readonly experiment: boolean | null | undefined;
          readonly linkedFrom: {
            readonly productTemplateCollection: {
              readonly total: number;
            } | null | undefined;
          } | null | undefined;
          readonly shortDescriptionOneLiner: string | null | undefined;
          readonly sys: {
            readonly id: string;
          };
          readonly urlSlug: string | null | undefined;
        } | null | undefined>;
        readonly total: number;
      } | null | undefined;
    } | null | undefined>;
  } | null | undefined;
  readonly productTemplateCollection: {
    readonly items: ReadonlyArray<{
      readonly contributor: {
        readonly __typename: "Author";
        readonly name: string | null | undefined;
        readonly organization: {
          readonly name: string | null | undefined;
        } | null | undefined;
      } | {
        readonly __typename: "CompanyNameInternal";
        readonly name: string | null | undefined;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null | undefined;
      readonly name: string | null | undefined;
      readonly previewBlurb: string | null | undefined;
      readonly productCollection: {
        readonly items: ReadonlyArray<{
          readonly productNameReference: {
            readonly productNameId: string | null | undefined;
          } | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly templateType: {
        readonly items: ReadonlyArray<{
          readonly sys: {
            readonly id: string;
          };
          readonly templateTypeName: string | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly urlSlug: string | null | undefined;
    } | null | undefined>;
  } | null | undefined;
};
export type useSearchSuggestionsContentfulQuery = {
  response: useSearchSuggestionsContentfulQuery$data;
  variables: useSearchSuggestionsContentfulQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locale"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 400
  },
  {
    "kind": "Variable",
    "name": "locale",
    "variableName": "locale"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 1
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlSlug",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Sys",
  "kind": "LinkedField",
  "name": "sys",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = [
  {
    "alias": "name",
    "args": null,
    "kind": "ScalarField",
    "name": "organizationNameExternal",
    "storageKey": null
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "total",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": (v1/*: any*/),
    "concreteType": "ProductTemplateCollection",
    "kind": "LinkedField",
    "name": "productTemplateCollection",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductTemplate",
        "kind": "LinkedField",
        "name": "items",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "ProductTemplateProductCollection",
            "kind": "LinkedField",
            "name": "productCollection",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductListing",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductName",
                    "kind": "LinkedField",
                    "name": "productNameReference",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "productNameId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "productCollection(limit:1)"
          },
          (v3/*: any*/),
          {
            "alias": "name",
            "args": null,
            "kind": "ScalarField",
            "name": "templateNameExternal",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "previewBlurb",
            "storageKey": null
          },
          {
            "alias": "templateType",
            "args": null,
            "concreteType": "ProductTemplateTemplateTypeCollection",
            "kind": "LinkedField",
            "name": "templateTypeCollection",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TaxonomyTemplateType",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": "templateTypeName",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "templateTypeNameExternal",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "contributor",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "CompanyNameInternal",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "name",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "authorNameExternal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanyNameInternal",
                    "kind": "LinkedField",
                    "name": "organization",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "Author",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": "categories",
    "args": (v1/*: any*/),
    "concreteType": "ProductTemplateCollection",
    "kind": "LinkedField",
    "name": "productTemplateCollection",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductTemplate",
        "kind": "LinkedField",
        "name": "items",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 10
              }
            ],
            "concreteType": "ProductTemplateCategoryCollection",
            "kind": "LinkedField",
            "name": "categoryCollection",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TaxonomyTemplateCategory",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "categoryNameInternal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "categoryNameExternal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "shortDescriptionOneLiner",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "experiment",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "allowedLocales",
                        "value": [
                          "en-US",
                          "es",
                          "ja-JP",
                          "pt-BR",
                          "fr-FR",
                          "de-DE",
                          "nl-NL",
                          "it-IT",
                          "ko-KR",
                          "pl-PL",
                          "ru-RU",
                          "zh-CN"
                        ]
                      }
                    ],
                    "concreteType": "TaxonomyTemplateCategoryLinkingCollections",
                    "kind": "LinkedField",
                    "name": "linkedFrom",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v2/*: any*/),
                        "concreteType": "ProductTemplateCollection",
                        "kind": "LinkedField",
                        "name": "productTemplateCollection",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/)
                        ],
                        "storageKey": "productTemplateCollection(limit:1)"
                      }
                    ],
                    "storageKey": "linkedFrom(allowedLocales:[\"en-US\",\"es\",\"ja-JP\",\"pt-BR\",\"fr-FR\",\"de-DE\",\"nl-NL\",\"it-IT\",\"ko-KR\",\"pl-PL\",\"ru-RU\",\"zh-CN\"])"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "categoryCollection(limit:10)"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSearchSuggestionsContentfulQuery",
    "selections": (v7/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSearchSuggestionsContentfulQuery",
    "selections": (v7/*: any*/)
  },
  "params": {
    "cacheID": "385dcd8f610edb64f1c2344d4c969c72",
    "id": null,
    "metadata": {},
    "name": "useSearchSuggestionsContentfulQuery",
    "operationKind": "query",
    "text": "query useSearchSuggestionsContentfulQuery(\n  $locale: String!\n) {\n  productTemplateCollection(limit: 400, locale: $locale) {\n    items {\n      productCollection(limit: 1) {\n        items {\n          productNameReference {\n            productNameId\n          }\n        }\n      }\n      urlSlug\n      name: templateNameExternal\n      previewBlurb\n      templateType: templateTypeCollection {\n        items {\n          sys {\n            id\n          }\n          templateTypeName: templateTypeNameExternal\n        }\n      }\n      contributor {\n        __typename\n        ... on CompanyNameInternal {\n          name: organizationNameExternal\n        }\n        ... on Author {\n          name: authorNameExternal\n          organization {\n            name: organizationNameExternal\n          }\n        }\n      }\n    }\n  }\n  categories: productTemplateCollection(limit: 400, locale: $locale) {\n    items {\n      categoryCollection(limit: 10) {\n        total\n        items {\n          sys {\n            id\n          }\n          urlSlug\n          categoryNameInternal\n          categoryNameExternal\n          shortDescriptionOneLiner\n          experiment\n          linkedFrom(allowedLocales: [\"en-US\", \"es\", \"ja-JP\", \"pt-BR\", \"fr-FR\", \"de-DE\", \"nl-NL\", \"it-IT\", \"ko-KR\", \"pl-PL\", \"ru-RU\", \"zh-CN\"]) {\n            productTemplateCollection(limit: 1) {\n              total\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bad30a2b552ba0b5e9d40ffb134f9af6";

export default node;
